import React from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png"

export default function RefundPolicy() {
  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}

        <section
        className="relative py-28 bg-cover bg-center"
        style={{
            backgroundImage: `url(${hearderbg})`,
        }}
      >
        {/* Dark overlay for readability */}
        {/* <div className="absolute inset-0 bg-black/60"></div> */}

        {/* Optional gradient overlay for premium feel */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white animate-fadeUp">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
               Refund & Cancellation Policy
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
              Understand when refunds are applicable and how cancellations work.
          </p>
        </div>
      </section>
      {/* <section className="relative py-28 bg-gradient-to-br from-indigo-600 via-purple-600 to-cyan-500">
        <div className="absolute inset-0 bg-black/30"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Refund & Cancellation Policy
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
            Understand when refunds are applicable and how cancellations work.
          </p>
        </div>
      </section> */}

      {/* REFUND CONTENT */}
      <section className="relative py-24 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-6 space-y-10">

          {/* Overview */}
          <div className="glass rounded-2xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Overview
            </h2>
            <p className="text-gray-700 leading-relaxed">
              This page explains the Refund and Cancellation Policy applicable
              to transactions executed through the BingoPays platform. The
              policy describes when refunds are made and the conditions for
              cancellation.
            </p>
          </div>

          {/* Refund & Cancellation Rights */}
          <div className="glass rounded-2xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Refund and Cancellation Rights
            </h2>
            <p className="text-gray-700 leading-relaxed">
              BingoPays reserves the right to refuse or cancel any
              transaction or order at its sole discretion.
            </p>

            <ul className="list-disc list-inside text-gray-700 mt-3 space-y-2">
              <li>Cancellation due to suspected fraudulent transactions.</li>
              <li>
                Cancellation if the transaction is not in accordance with the
                Terms of Use.
              </li>
              <li>
                Cancellation for reasons outside the control of BingoPays,
                including government or regulatory situations.
              </li>
            </ul>
          </div>

          {/* Refund Handling */}
          <div className="glass rounded-2xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Refund Handling
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Refunds and cancellations are processed based on the transaction
              status and platform rules.
            </p>

            <ul className="list-disc list-inside text-gray-700 mt-3 space-y-2">
              <li>
                If an online transaction fails or is cancelled, the amount will
                be refunded.
              </li>
              <li>
                In case of double deduction for the same transaction, the full
                amount debited will be refunded.
              </li>
              <li>
                Any bank or card transaction charges may be forfeited and are
                not guaranteed to be refunded.
              </li>
              <li>
                BingoPays does not guarantee the time required for a refund to
                reflect in the customer’s account.
              </li>
              <li>
                For partial cancellations, only the corresponding amount will
                be refunded.
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="glass rounded-2xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Need Help?
            </h2>
            <p className="text-gray-700 leading-relaxed">
              If you have questions related to a refund or cancellation,
              please contact our support team:
            </p>

            <ul className="list-disc list-inside text-gray-700 mt-3 space-y-2">
              <li>Email: Info@bingopays.in</li>
              <li>Phone: +91 8586 036 036</li>
              <li>
                Registered Address: #879/13, Kurukshetra, Haryana – 136118
              </li>
            </ul>
          </div>

        </div>
      </section>

    </div>
  );
}
